import MainListRequest from "../components/list-request/main-list-request";


function ListingRequest() {
  return (
    <div>
        <MainListRequest/>
    </div>
  );
}

export default ListingRequest;
